/**
 * Style config for Pipedream's CustomizeProvider component. This will provide styling for the Pipedream Triggers configuration form.
 */
const pipedreamCustomiseConfig = {
  styles: {
    componentForm: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.375rem',
      padding: '0.75rem',
      backgroundColor: 'var(--color-bg-paper)',
      border: '1px solid var(--color-divider)',
      borderRadius: '8px',
      boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    field: {
      display: 'grid',
      gridTemplateAreas: '"label label" "control control" "description description" "error error"',
      gridTemplateColumns: 'min-content auto',
      gap: '0.0625rem 0px',
      alignItems: 'start',
      fontSize: '0.875rem',
    },
    label: {
      color: 'var(--color-text-primary)',
      fontWeight: 500,
      fontSize: '0.875rem',
      lineHeight: 1.25,
      gridArea: 'label',
      marginBottom: '0.125rem',
    },
    connectButton: (base, { disabled }) => ({
      ...base,
      backgroundColor: disabled ? 'var(--color-bg-subtle)' : 'var(--color-text-primary)',
      border: `1px solid var(--color-text-primary)`,
      borderRadius: '6px',
      color: disabled ? 'var(--color-text-disabled)' : 'var(--color-bg-paper)',
      padding: '0.25rem 0.5rem',
      fontSize: '0.875rem',
      fontWeight: 500,
      fontFamily: 'inherit',
      cursor: disabled ? 'not-allowed' : 'pointer',
      transition: 'all 0.2s ease-in-out',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      whiteSpace: 'nowrap',
      textDecoration: 'none',
      outline: 'none',
      boxShadow: !disabled ? '0 1px 2px 0 rgb(0 0 0 / 0.05)' : undefined,
      filter: !disabled ? undefined : 'brightness(0.9)',
    }),
    description: { display: 'none' },
    errors: { display: 'none' },
    error: { display: 'none' },
    controlInput: (base, { isDisabled }) => ({
      ...base,
      backgroundColor: isDisabled ? 'var(--color-bg-subtle)' : 'var(--color-bg-paper)',
      border: '1px solid var(--color-divider)',
      borderRadius: '6px',
      minHeight: '28px',
      boxShadow: 'none',
      transition: 'all 0.2s ease-in-out',
      padding: '0.25rem 0.375rem',
      cursor: isDisabled ? 'not-allowed' : undefined,
    }),
    controlSelect: {
      control: (base, { theme }) => ({
        ...base,
        backgroundColor: 'var(--color-bg-paper)',
        border: '1px solid var(--color-divider)',
        borderRadius: '6px',
        minHeight: '28px',
        boxShadow: 'none',
        transition: 'all 0.2s ease-in-out',
        fontSize: '0.875rem',
        '&:hover': {
          borderColor: 'var(--color-text-disabled)',
        },
      }),
      input: base => ({
        ...base,
        padding: '0.25rem 0.375rem',
        color: 'var(--color-text-primary)',
      }),
      menu: base => ({
        ...base,
        backgroundColor: 'var(--color-bg-paper)',
        border: '1px solid var(--color-divider)',
        borderRadius: '6px',
        boxShadow: '0 4px 12px rgb(0 0 0 / 0.15)',
        overflow: 'hidden',
      }),
      menuList: base => ({
        ...base,
        backgroundColor: 'var(--color-bg-paper)',
      }),
      option: (base, { isFocused, isSelected }) => ({
        ...base,
        backgroundColor: isSelected
          ? 'var(--color-action-selected)'
          : isFocused
            ? 'var(--color-action-hover)'
            : 'transparent',
        color: 'var(--color-text-primary)',
        fontSize: '0.875rem',
        cursor: 'pointer',
        '&:active': {
          backgroundColor: 'var(--color-action-selected)',
        },
      }),
      singleValue: base => ({
        ...base,
        color: 'var(--color-text-primary)',
      }),
      placeholder: base => ({
        ...base,
        color: 'var(--color-text-secondary)',
      }),
      noOptionsMessage: base => ({
        ...base,
        color: 'var(--color-text-secondary)',
      }),
    },
    pdAlertInfo: { display: 'none' },
    optionalFieldButton: {
      backgroundColor: 'var(--color-bg-subtle)',
      border: '1px solid var(--color-divider)',
      borderRadius: '6px',
      color: 'var(--color-text-secondary)',
      padding: '0.25rem 0.5rem',
      fontSize: '0.8125rem',
      fontWeight: 500,
      fontFamily: 'inherit',
      cursor: 'pointer',
      transition: 'all 0.2s ease-in-out',
    },
    heading: {},
    optionalFields: {},
  },
};

export default pipedreamCustomiseConfig;
